import React, { useEffect, useState } from "react";
import moment from "moment";
import DataTableComponent from "../reusableComponents/DataTable";
import deleteIcon from "../../images/dustbin.png";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import DialogComponent from "../reusableComponents/Dialog";
import AddVendor from "./AddVendor";
import { vendorDelete } from "./httpCalls";
import { useDispatch, useSelector } from "react-redux";
import { getVendors, removeVendor } from "./vendorSlice";
import { Box, Button, Typography } from "@mui/material";
import Loader from "../components/Loader";

const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
      background: "white",
      padding: "2px 10px",
      marginTop: "5px",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
      marginTop: "5px !important",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "16px",
    },
  },
  cells: {
    style: {
      paddingLeft: "18px",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },
};

function Vendors() {
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const tokenType = localStorage.getItem("tokenType");
  const vendor = useSelector((state) => state.vendor);

  const [state, setState] = useState({
    modal: false,
    addModal: false,
    mutation: false,
    vendorId: "",
  });

  useEffect(() => {
    dispatch(getVendors());
  }, []);
  const columns = [
    {
      name: "#",
      width: "100px",
      selector: (row, index) => index + 1,
    },
    {
      name: "Name",
      selector: (row) => row?.companyName,
    },
    {
      name: "City",
      selector: (row) => row?.city,
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
    },
    {
      name: "Date",
      selector: (row) =>
        row.created_at
          ? moment.unix(row.created_at).format("DD-MM-YYYY")
          : moment.unix(row.date).format("DD-MM-YYYY"),
    },
    {
      name: "Action",
      width: "100px",
      cell: (row) => {
        return tokenType == "admin" ? (
          <img
            style={{ margin: "0 auto", cursor: "pointer" }}
            height="25px"
            width="20"
            src={deleteIcon}
            alt="delete"
            onClick={() => handleClick(row)}
          />
        ) : null;
      },
    },
  ];
  const handleClick = (row) => {
    setState((prevState) => ({
      ...prevState,
      modal: !state.modal,
      vendorId: row._id,
    }));
  };
  const toggle = () => {
    setState((prevState) => ({ ...prevState, modal: !state.modal }));
  };
  const addToggle = () => {
    setState((prevState) => ({ ...prevState, addModal: !state.addModal }));
  };
  const deleteVendor = async () => {
    let foundIndex;
    let found = vendor.vendors.find((item, index) => {
      if (item._id == state.vendorId) {
        foundIndex = index;
        return item;
      }
    });
    dispatch(removeVendor(found));

    setState((prevState) => ({
      ...prevState,
      modal: !prevState.modal,
    }));

    vendorDelete(companyCode, state.vendorId, found, foundIndex, dispatch);
  };

  return (
    <Box sx={{ pt: 2, mt: { md: "0px", xs: "40px" } }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0px",
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: "#4EAF51", fontSize: { md: "2.125rem", xs: "16px" } }}
        >
          Items Brands
        </Typography>
        <Button
          variant="contained"
          sx={{ background: "#4EAF51", color: "white" }}
          onClick={addToggle}
        >
          Add Items Brands
        </Button>
      </Box>
      <DataTableComponent
        columns={columns}
        data={vendor.vendors}
        highlightOnHover
        customStyles={customStyles}
      />
      <DeleteDialog
        title="Delete Items Brands"
        open={state.modal}
        onClose={toggle}
        onClickYes={deleteVendor}
      />

      <DialogComponent
        title="Add Items Brands"
        open={state.addModal}
        onClose={addToggle}
        onClickCancel={addToggle}
        dialogContent={<AddVendor onClose={addToggle} />}
      />
      <Loader loading={vendor.loading} />
    </Box>
  );
}

export default Vendors;
